// B
import BootstrapVue from 'bootstrap-vue'
import { Button } from 'element-ui'

// C
import CustomInput from '@/components/Utils/CustomInput.vue'
import CustomSearchInput from '@/components/Utils/CustomSearchInput.vue'
import CustomCheckbox from '@/components/Utils/CustomCheckbox.vue'
import CustomButton from '@/components/Utils/CustomButton.vue'
import CustomTextInput from '@/components/Utils/CustomTextInput.vue'
import CustomPhoneInput from '@/components/Utils/CustomPhoneInput.vue'
import CustomDatePicker from '@/components/Utils/CustomDatePicker.vue'
import CustomMultipleSelect2 from '@/components/Utils/CustomMultipleSelect2.vue'
import CustomSelect from '@/components/Utils/CustomSelect.vue'
import CustomSelectSlot from '@/components/Utils/CustomSelectSlot.vue'
import CustomFilterDateSelect from '@/components/Utils/CustomFilterDateSelect.vue'
import CustomAvatar from '@/components/Utils/CustomAvatar'
import Logo from '@/components/Utils/Logo'
import { Collapse, CollapseItem } from 'element-ui'
import CustomImageViewer from '@/components/Utils/CustomImageViewer'

// D
import { DatePicker } from 'element-ui'
import { Dropdown, DropdownMenu, DropdownItem } from 'element-ui'

// E
import ExternalTrackers from '@/services/ExternalTrackers'

// F
import FunctionalCalendar from 'vue-functional-calendar'

// I
import Icon from 'vue-awesome/components/Icon'
import InfiniteLoading from 'vue-infinite-loading'

// M
import moment from 'moment'
require('moment/locale/pt-br')
require('moment/locale/en-au')
import Multiselect from 'vue-multiselect'

// N
import Notifications from 'vue-notification'

// P
import { Progress } from 'element-ui'

//R
import { Rate } from 'element-ui'

//T
import { Tree, Tabs, TabPane } from 'element-ui'

// V
import VueYoutube from 'vue-youtube'

import VueSplit from 'vue-split-panel'
import VueI18n from 'vue-i18n'
import VueKonva from 'vue-konva'
import Vue2TouchEvents from 'vue2-touch-events'

import 'element-ui/lib/theme-chalk/index.css'

// Services
import Mobile from '../services/Mobile'

import 'vue-multiselect/dist/vue-multiselect.min.css'

/**
 * Summary.
 * Use this method to start customing a a current Vue instance
 * @param {Object} instance - Vue instance
 *
 * @return {Object} Returns a new Vue instance
 */
export default function setupVue(instance) {
    instance.use(Notifications)
    instance.use(BootstrapVue)
    instance.use(VueSplit)
    instance.use(Vue2TouchEvents)
    instance.use(VueYoutube)
    instance.use(require('vue-moment'), {
        moment,
    })
    instance.use(VueI18n)
    instance.use(VueKonva)
    instance.use(InfiniteLoading)
    instance.use(FunctionalCalendar)

    // Custom components
    instance.component('ci-input', CustomInput)
    instance.component('ci-search-input', CustomSearchInput)
    instance.component('ci-checkbox', CustomCheckbox)
    instance.component('ci-button', CustomButton)
    instance.component('ci-text-input', CustomTextInput)
    instance.component('ci-date-input', CustomDatePicker)
    instance.component('ci-multiple-select2', CustomMultipleSelect2)
    instance.component('ci-select', CustomSelect)
    instance.component('ci-select-slot', CustomSelectSlot)
    instance.component('ci-filter-date-select', CustomFilterDateSelect)
    instance.component('ci-avatar', CustomAvatar)
    instance.component('ci-logo', Logo)
    instance.component('ci-image-viewer', CustomImageViewer)
    instance.component('ci-phone-input', CustomPhoneInput)

    // Element UI
    instance.component(Tree.name, Tree)
    instance.component(Tabs.name, Tabs)
    instance.component(TabPane.name, TabPane)
    instance.component(Rate.name, Rate)
    instance.component(DatePicker.name, DatePicker)
    instance.component(Progress.name, Progress)
    instance.component(Dropdown.name, Dropdown)
    instance.component(DropdownItem.name, DropdownItem)
    instance.component(DropdownMenu.name, DropdownMenu)
    instance.component(Button.name, Button)
    instance.component(Collapse.name, Collapse)
    instance.component(CollapseItem.name, CollapseItem)

    instance.component('icon', Icon)
    instance.component('multiselect', Multiselect)

    instance.config.productionTip = false

    instance.prototype.$Mobile = new Mobile()
    instance.prototype.$ExternalTrackers = ExternalTrackers
    instance.prototype.moment = moment

    return instance
}
